import { CommonSubmissionItemCardProps, SubmissionItemCard } from '@/components/AppStoreItems/AppStoreItemsCard';
import { antGrey } from '@/components/styles/globalStyles';
import { AppStoreReviewSubmissionItemType, CustomProductPage } from '@/types';
import { globalMessage } from '@/utils/globalMessage';
import { LinkOutlined } from '@ant-design/icons';
import Button from 'antd/lib/button';
import Space from 'antd/lib/space';
import Text from 'antd/lib/typography/Text';
import * as React from 'react';

export interface CustomProductPageCardProps extends CommonSubmissionItemCardProps {
    customProductPage: CustomProductPage;
}

export const CustomProductPageCard: React.FC<CustomProductPageCardProps> = ({ customProductPage, ...rest }) => {
    return (
        <SubmissionItemCard
            item={customProductPage}
            type={AppStoreReviewSubmissionItemType.CustomProductPage}
            {...rest}
        >
            <Text style={{ fontWeight: 400, color: antGrey.grey9, fontSize: 14 }}>{customProductPage.name}</Text>
            <div
                style={{
                    display: 'flex',
                    gap: 6,
                    height: 149,
                    alignItems: 'start',
                }}
            >
                {customProductPage.firstVersionLocalization?.appPreviewSets?.[0]?.appPreviews.map(
                    (appPreview, index) => {
                        return (
                            <img
                                key={index}
                                src={appPreview.previewImageUrl}
                                style={{
                                    maxHeight: 149,
                                    borderRadius: 4,
                                }}
                            />
                        );
                    },
                )}

                {customProductPage.firstVersionLocalization?.screenshotSets?.[0]?.screenshots.map(
                    (screenshot, index) => {
                        return (
                            <img
                                key={index}
                                src={screenshot.url}
                                style={{
                                    maxHeight: 149,
                                    borderRadius: 4,
                                }}
                            />
                        );
                    },
                )}
            </div>
            <div
                style={{
                    display: 'flex',
                    width: '100%',
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'end',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 20,
                        justifyContent: 'end',
                    }}
                >
                    <Text style={{ fontWeight: 400, color: antGrey.grey8 }}>
                        {customProductPage.firstVersionLocalization?.promotionalText}
                    </Text>
                    <Space>
                        <Text style={{ fontWeight: 400, color: antGrey.grey7, maxWidth: 290 }} ellipsis>
                            {customProductPage.url}
                        </Text>
                        <Button
                            type="link"
                            icon={<LinkOutlined />}
                            onClick={() => {
                                navigator.clipboard.writeText(customProductPage.url);
                                globalMessage.success('Link copied to clipboard!');
                            }}
                        >
                            Copy Link
                        </Button>
                    </Space>
                </div>
            </div>
        </SubmissionItemCard>
    );
};
